import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {fetchedPage, loadPage} from "../../actions/page";
import TopBar from "../layout/TopBar";
import Loader from "react-loader";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";

class RegionListPage extends React.Component {


    componentWillUnmount() {
        this.props.loadPage()
    }
    componentDidMount() {
        this.props.fetchedPage('/api/' + this.props.location.pathname).then();
    }

    render() {
        const {page, modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={"transition-item detail-page"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <h1>{page.title}</h1>
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

RegionListPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(RegionListPage);




// WEBPACK FOOTER //
// ./src/components/pages/RegionListPage.js